export const GA_FILTER_CLEAR_ONE_LABEL = 'clear one';
export const GA_FILTER_CLEAR_ALL_LABEL = 'clear all';

export const GA_SEARCH_HEADER_LABEL = 'header';
export const GA_SEARCH_BURGER_LABEL = 'burger menu';

export const GA_MY_BOOZT_LABELS = {
    moreOrderDetails: 'more order details',
    createReturn: 'create return',
    createClaim: 'create claim'
};

export const GA_ONLINE_RETURN_LABELS = {
    getVoucher: 'Get voucher',
    copyVoucher: 'Copy voucher',
    buyMore: 'Buy more'
};

export const GA_BOOZTPAY_LABELS = {
    overdueInvoice: 'overdue invoice',
    payNow: 'pay now',
    viewAsPdf: 'view as pdf',
    contactUs: 'contact us',
    postponeInvoice: 'postpone invoice',
    confirm: 'confirm',
    seeAll: 'see all',
    cancel: 'cancel'
};
